




import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import SwitchField from '@/components/Form/SwitchField.vue';

// Services
import * as Sentry from '@sentry/browser';
import Staff from '@/services/Staff';

@Component({
	name: 'UserManagementUserSwitch',
	components: {
		SwitchField,
	},
})
export default class UserSwitch extends Vue {
	@Prop() private sub: string;
	@Prop() private status: boolean;

	@Watch('status')
	private async watchUserEnabled() {
		const sendData = {
			cmd: this.status ? ('enable' as const) : ('disable' as const),
			sub: this.sub,
		};

		try {
			const updateUser = await Staff.updateUser(sendData);
		} catch (e) {
			Sentry.captureException(e);
		}
	}
}
